import React from "react";
import styled from "styled-components";

const TitanTime = ({ time }) => {
  if (!time) return null;
  return (
    <TimeP>
      <strong>{time}</strong>
    </TimeP>
  );
};

const TimeP = styled.p`
  color: #fff;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;

  strong {
    color: #ff8f00;
  }
`;

export default TitanTime;
